/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { api } from '../api';
import { toast, useAutoSave, autoSaveManager } from '../utils';
import { T, BG } from '../tema';
import {
 Glas, Label, Input, Textarea, Select, Knap, BekræftDialog,
 PostnrBy, CprFelt, Filer, TrinNavigation,
 TRIN_META, SAGSTYPER, FORÆLDREMY, BOPÆL_OPT,
 HjaelpIkon,
} from './Ui';
// Sagstyper der endnu ikke er en reel klientsag — samme lempede krav som
// "Leads" (intet tlf/adresse/sagsbehandler-krav, status sættes til 'lead').
const LEAD_AGTIGE_TYPER = ['leads', 'gratis afklaringssamtale'];
const er_lead_type = type => LEAD_AGTIGE_TYPER.includes(type?.toLowerCase());
function NyKlient({ onFærdig, onAnnuller, redigering = null }) {
 // redigering = { sag_id, klient_id, sagsnummer } ved redigering af eksisterende
 const [aktivt, setAktivt] = useState("klient");
 const [oprettet, setOprettet] = useState(false);
 const [sagsnummer, setSagsnummer] = useState(redigering?.sagsnummer || "");
 const [fejl, setFejl] = useState({});
 const [indlæser, setIndlæser] = useState(!!redigering);
 const [klient, setKlient] = useState({ fornavn:"",efternavn:"",cpr:"",telefon:"",email:"",adresse:"",postnr:"",by:"" });
 const [gemmer, setGemmer] = useState(false);
 const [sag, setSag] = useState({ type:"",klient_maal:"",honorar:"",vis_manuelt_nr:false,manuelt_nr:"",primær_id:"",primær_navn:"" });
 const [bekræft_slet_kladde, setBekræftSletKladde] = useState(false);
 // Oprindelig status ved indlæsning — bruges til at opdage lead → reel sagstype-overgang
 const oprindelig_status = useRef(null);
 // U2: Auto-save draft i localStorage hvert 30s (kun ved ny klient, ikke redigering)
 const draft_nøgle = redigering ? null : 'ny-klient-wizard';
 useAutoSave(draft_nøgle, { klient, sag }, { aktiv: !redigering && !oprettet });
 // Gendan draft ved mount (hvis der er en fra sidste session)
 React.useEffect(() => {
 if (redigering) return;
 const draft = autoSaveManager.hent('ny-klient-wizard');
 if (draft && (draft.klient?.fornavn || draft.klient?.efternavn || draft.sag?.type)) {
 const raw_entry = (() => { try { return JSON.parse(localStorage.getItem('sv_draft_ny-klient-wizard')); } catch(_) { return null; } })();
 const tid_tekst = raw_entry?.tid ? new Date(raw_entry.tid).toLocaleTimeString('da-DK', { hour: '2-digit', minute: '2-digit' }) : '';
 toast(`Kladde genoprettet${tid_tekst ? ` (gemt ${tid_tekst})` : ''} — formular gendannet fra forrige session`, 'info', {
 varighed: 6000,
 action: 'Slet kladde',
 onAction: () => setBekræftSletKladde(true)
 });
 if (draft.klient) setKlient(draft.klient);
 if (draft.sag) setSag(draft.sag);
 }
 // eslint-disable-next-line react-hooks/exhaustive-deps
 }, []);
 // Hent sagstyper fra DB (Admin → Sagstyper er source of truth)
 const [db_sagstyper, setDbSagstyper] = useState([]);
 React.useEffect(() => {
 api("indstillinger/sag_typer").then(d => {
 if (d?.items) setDbSagstyper(d.items.filter(x => x.aktiv !== false));
 }).catch(() => {});
 }, []);
 // Flet DB-sagstyper med hardkodet enum (for bagudkompatibilitet)
 const sagstype_options = db_sagstyper.length > 0
 ? db_sagstyper.map(t => ({ v: t.navn, l: t.navn, farve: t.farve }))
 : SAGSTYPER;
 // Sæt indlogget bruger som standard primær sagsbehandler
 React.useEffect(() => {
 try {
 const gem_bruger = JSON.parse(sessionStorage.getItem("sv_bruger") || "{}");
 if (gem_bruger.id) setSag(p => ({...p, primær_id: String(gem_bruger.id), primær_navn: gem_bruger.navn || ""}));
 } catch {}
 }, []);
 const [modpart, setModpart] = useState({ fornavn:"",efternavn:"",email:"",telefon:"",adresse:"",postnr:"",by:"",advokat:"" });
 const [boern, setBoern] = useState([]);
 const [noter, setNoter] = useState({ opstart:"",vigtige_datoer:"",strategi:"",filer:[] });
 const [fuldmagt_trin, setFuldmagtTrin] = useState(null); // null | 'spørg' | 'vælg_børn' | 'klar'
 const [fuldmagt_valgte_boern, setFuldmagtValgteBoern] = useState([]);
 const [fuldmagt_loading, setFuldmagtLoading] = useState(false);
 const [fuldmagt_pdf, setFuldmagtPdf] = useState(null); // { pdf_base64, filnavn, ... }
 const [oprettet_sag_id, setOprettetSagId] = useState(null);
 const [oprettet_klient_id, setOprettetKlientId] = useState(null);
 const [ny_klient_brugere, setNyKlientBrugere] = useState([]);
 React.useEffect(() => {
 // FEJL-002-fix: GET /api/brugere kræver admin-rolle (403 for sagsbehandlere), så
 // "Primær sagsbehandler"-feltet i sag-trinnet skal bruge det åbne
 // /sagsbehandlere-endpoint, der allerede filtrerer på aktiv=true og ekskluderer
 // infoskærm-rollen.
 api("brugere/sagsbehandlere").then(data => {
 if (data?.brugere) setNyKlientBrugere(data.brugere.filter(b => b.rolle !== "systemadmin" && b.id !== 1));
 }).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); });
 }, []);
 // Hent eksisterende data ved redigering
 React.useEffect(() => {
 if (!redigering) return;
 Promise.all([
 api("klienter/" + redigering.klient_id),
 api("sager").then(d => d?.sager?.find(s => String(s.id) === String(redigering.sag_id))),
 api("haendelser/" + redigering.sag_id),
 api("sager/" + redigering.sag_id + "/boern").catch(() => null),
 ]).then(([klient_res, sag_data, haendelser_res, boern_db_res]) => {
 if (klient_res?.klient) {
 const k = klient_res.klient;
 setKlient({ fornavn:k.fornavn||"", efternavn:k.efternavn||"", cpr:k.cpr_krypteret||"", telefon:k.telefon||"", email:k.email||"", adresse:k.adresse||"", postnr:k.postnr||"", by:k.by||"" });
 }
 if (sag_data) {
 setSag(p => ({ ...p, type:sag_data.type||"", klient_maal:sag_data.klient_maal||"", honorar:sag_data.aftaler||"" }));
 oprindelig_status.current = sag_data.status || null;
 }
 // Hent modpart og børn fra hændelser
 if (haendelser_res?.haendelser) {
 const modpart_h = haendelser_res.haendelser.find(h => h.titel === "Modpartoplysninger");
 const boern_h = haendelser_res.haendelser.find(h => h.titel === "Børneoplysninger (GDPR niveau 2)");
 if (modpart_h?.beskrivelse) {
 // Parse modpart tekst tilbage til felter
 const linjer = modpart_h.beskrivelse.split("\n");
 const navn = linjer[0]?.split(" ") || [];
 const adr_linje = linjer.find(l=>l.startsWith("Adresse: "))?.replace("Adresse: ","") || "";
 const postnr_m = adr_linje.match(/\b(\d{4})\b/);
 const postnr_v = postnr_m?.[1] || "";
 const by_v = postnr_v ? adr_linje.slice(adr_linje.indexOf(postnr_v) + postnr_v.length).trim() : "";
 const adresse_v = postnr_v ? adr_linje.slice(0, adr_linje.indexOf(postnr_v)).trim() : adr_linje;
 setModpart(p => ({
 ...p,
 fornavn: navn[0] || "",
 efternavn: navn.slice(1).join(" ") || "",
 email: linjer.find(l=>l.startsWith("Email: "))?.replace("Email: ","") || "",
 telefon: linjer.find(l=>l.startsWith("Tlf: "))?.replace("Tlf: ","") || "",
 advokat: linjer.find(l=>l.startsWith("Advokat: "))?.replace("Advokat: ","") || "",
 adresse: adresse_v,
 postnr: postnr_v,
 by: by_v,
 }));
 }
 if (boern_h?.beskrivelse) {
 const db_boern = boern_db_res?.boern || [];
 const nye_boern = boern_h.beskrivelse.split("\n").map((linje, i) => {
 const match = linje.match(/Barn \d+: (.+?)(?:\s*\(CPR: (.+?)\))?(?:\s*·\s*Forældremyndighed: (.+?))?(?:\s*·\s*Bopæl: (.+?))?$/);
 if (!match) return null;
 const navnDele = (match[1]||"").trim().split(" ");
 const fornavn = navnDele[0] || "";
 const efternavn = navnDele.slice(1).join(" ") || "";
 // Match mod DB-post for at sætte db_id — forhindrer re-oprettelse ved næste gem
 const db_match = db_boern.find(b =>
   b.fornavn.toLowerCase() === fornavn.toLowerCase() &&
   b.efternavn.toLowerCase() === efternavn.toLowerCase()
 );
 return { id: db_match?.id || Date.now()+i, db_id: db_match?.id, fornavn, efternavn, cpr:match[2]||"", forældremyndighed:match[3]||"", bopæl:match[4]||"", omhandler:"" };
 }).filter(Boolean);
 if (nye_boern.length > 0) setBoern(nye_boern);
 }
 }
 setIndlæser(false);
 }).catch(() => setIndlæser(false));
 }, [redigering?.sag_id]);
 if (indlæser) return (
 <div style={{ minHeight:"100vh", background:BG, display:"flex", alignItems:"center", justifyContent:"center", padding:"0 24px" }}> <div style={{ width:"100%", maxWidth:640 }}>
 {/* Trinnavigation skeleton */}
 <div style={{ display:"flex", gap:8, marginBottom:24, justifyContent:"center" }}>
 {[1,2,3,4,5].map(i => (
 <div key={i} style={{ width:36, height:36, borderRadius:"50%", background:"rgba(255,255,255,0.07)", animation:"skeletonPulse 1.5s ease infinite", animationDelay:`${i*0.1}s` }} />
 ))}
 </div>
 {/* Form card skeleton */}
 <div style={{ background:"rgba(255,255,255,0.04)", borderRadius:16, padding:"28px 32px", border:"1px solid rgba(255,255,255,0.08)" }}>
 {/* Section title */}
 <div style={{ height:20, width:"45%", background:"rgba(255,255,255,0.08)", borderRadius:6, marginBottom:28, animation:"skeletonPulse 1.5s ease infinite" }} />
 {/* Field rows */}
 {[100,80,100,60].map((w, i) => (
 <div key={i} style={{ marginBottom:20 }}> <div style={{ height:11, width:`${w * 0.3}%`, background:"rgba(255,255,255,0.05)", borderRadius:4, marginBottom:8, animation:"skeletonPulse 1.5s ease infinite" }} /> <div style={{ height:42, background:"rgba(255,255,255,0.05)", borderRadius:8, animation:"skeletonPulse 1.5s ease infinite", animationDelay:`${i*0.12}s` }} /> </div>
 ))}
 {/* Button row */}
 <div style={{ display:"flex", gap:12, marginTop:28, justifyContent:"flex-end" }}> <div style={{ height:40, width:100, background:"rgba(255,255,255,0.05)", borderRadius:8, animation:"skeletonPulse 1.5s ease infinite" }} /> <div style={{ height:40, width:130, background:"rgba(63,212,199,0.1)", borderRadius:8, animation:"skeletonPulse 1.5s ease infinite" }} /> </div> </div> </div> </div>
 );
 const k = felt => e => setKlient(p=>({...p,[felt]:e.target.value}));
 const s = felt => e => setSag(p=>({...p,[felt]:e.target.value}));
 const m = felt => e => setModpart(p=>({...p,[felt]:e.target.value}));
 const n = felt => e => setNoter(p=>({...p,[felt]:e.target.value}));
 // Status for trin-indikator
 const status = {
 klient: !!(klient.fornavn&&klient.efternavn&&(er_lead_type(sag.type)||klient.telefon)),
 sag: !!(sag.type&&(er_lead_type(sag.type)||sag.klient_maal)),
 modpart: !!(modpart.fornavn||modpart.efternavn),
 boern: boern.length>0,
 noter: !!(noter.opstart),
 bekræft: false,
 };
 const valider_felt = (felt, val) => {
 const regler = {
 fornavn: v => !v && "Fornavn er påkrævet",
 efternavn: v => !v && "Efternavn er påkrævet",
 cpr: v => (v && v.length < 11) && "Ugyldigt CPR-nummer (brug DDMMÅÅ-XXXX)",
 telefon: v => er_lead_type(sag.type) ? false : (!v && "Telefonnummer er påkrævet"),
 adresse: v => er_lead_type(sag.type) ? false : (!v && "Adresse er påkrævet"),
 postnr: v => er_lead_type(sag.type) ? false : (!v && "Postnummer er påkrævet"),
 by: v => er_lead_type(sag.type) ? false : (!v && "By er påkrævet"),
 klient_maal: v => er_lead_type(sag.type) ? false : (!v && "Beskriv klientens mål — hvad ønsker de at opnå?"),
 };
 const msg = regler[felt]?.(val);
 setFejl(p => msg ? { ...p, [felt]: msg } : (({ [felt]: _, ...rest }) => rest)(p));
 };
 const valider = () => {
 const e = {};
 const er_lead = er_lead_type(sag.type);
 if (!klient.fornavn) e.fornavn="Fornavn er påkrævet";
 if (!klient.efternavn) e.efternavn="Efternavn er påkrævet";
 if (klient.cpr&&klient.cpr.length<11) e.cpr="Ugyldigt CPR-nummer (brug DDMMÅÅ-XXXX)";
 if (!er_lead && !klient.telefon) e.telefon="Telefonnummer er påkrævet";
 if (!er_lead && !klient.adresse) e.adresse="Adresse er påkrævet";
 if (!er_lead && !klient.postnr) e.postnr="Postnummer er påkrævet";
 if (!er_lead && !klient.by) e.by="By er påkrævet";
 if (!sag.type) e.type="Vælg sagstype for at fortsætte";
 if (!er_lead && !sag.klient_maal) e.klient_maal="Beskriv klientens mål — hvad ønsker de at opnå?";
 if (!sag.primær_id && !er_lead) e.primær="Vælg primær sagsbehandler";
 setFejl(e);
 return Object.keys(e).length===0;
 };
 const opret = async () => {
 if (!valider()) { setAktivt("klient"); return; }
 setGemmer(true);
 try {
 if (redigering) {
 // ── REDIGERING: PATCH eksisterende ──
 await api("klienter/" + redigering.klient_id, "PATCH", {
 fornavn: klient.fornavn.trim(), efternavn: klient.efternavn.trim(),
 telefon: klient.telefon, email: klient.email,
 adresse: klient.adresse, postnr: klient.postnr, by: klient.by,
 });
 await api("sager/" + redigering.sag_id, "PATCH", {
 type: sag.type, klient_maal: sag.klient_maal, aftaler: sag.honorar,
 // Lead → reel sagstype: status skal følge med, ellers hænger sagen fast som 'lead'
 // selvom sagstypen ikke længere er lead-agtig (se SV-1121).
 ...(oprindelig_status.current === 'lead' && !er_lead_type(sag.type) ? { status: 'aktiv' } : {}),
 });
 const haendelser_res = await api("haendelser/" + redigering.sag_id);
 const eksisterende_h = haendelser_res?.haendelser || [];
 // Opdater eller opret modpart hændelse
 if (modpart.fornavn || modpart.efternavn) {
 const modpart_tekst = [
 [modpart.fornavn, modpart.efternavn].filter(Boolean).join(" "),
 modpart.email ? "Email: "+modpart.email : null,
 modpart.telefon ? "Tlf: "+modpart.telefon : null,
 modpart.adresse ? "Adresse: "+[modpart.adresse,modpart.postnr,modpart.by].filter(Boolean).join(" ") : null,
 modpart.advokat ? "Advokat: "+modpart.advokat : null,
 ].filter(Boolean).join("\n");
 const eksist = eksisterende_h.find(h => h.titel === "Modpartoplysninger");
 if (eksist) {
 await api("haendelser/" + eksist.id, "PATCH", { beskrivelse: modpart_tekst }).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); });
 } else {
 await api("haendelser", "POST", { sag_id: String(redigering.sag_id), type:"note", titel:"Modpartoplysninger", beskrivelse:modpart_tekst }).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); });
 }
 }
 // BOERN-FIX: Gem nye børn via POST + opdater eksisterende via PATCH.
 // Før blev de kun gemt som note, så fuldmagt-dialogen fandt 0 børn.
 if (boern.length > 0) {
 const nye_boern = boern.filter(b => !b.db_id);
 const eks_boern = boern.filter(b => b.db_id);
 // Nye børn via POST
 if (nye_boern.length > 0) {
 const boern_db_res = await api("sager/" + redigering.sag_id + "/boern", "POST", { boern: nye_boern }).catch(() => null);
 if (boern_db_res?.fejl) {
 toast(" Nye børn kunne ikke gemmes: " + boern_db_res.fejl, "fejl");
 } else if (boern_db_res?.boern) {
 let i = 0;
 boern_db_res.boern.forEach((db_barn) => {
 while (i < boern.length && boern[i].db_id) i++;
 if (boern[i]) { boern[i].db_id = db_barn.id; i++; }
 });
 }
 }
 // Eksisterende børn: PATCH så CPR/navn/forældremyndighed/bopæl bliver opdateret
 for (const b of eks_boern) {
 const patch_data = {
 fornavn: b.fornavn,
 efternavn: b.efternavn || "",
 forældremyndighed: b.forældremyndighed || null,
 bopæl: b.bopæl || null,
 };
 if (b.cpr && !String(b.cpr).includes("*")) patch_data.cpr = b.cpr;
 const r = await api(`sager/${redigering.sag_id}/boern/${b.db_id}`, "PATCH", patch_data).catch(() => null);
 if (r?.fejl) {
 toast(` ${b.fornavn}: ${r.fejl}`, "fejl");
 }
 }
 const boern_tekst = boern.map((b,i) =>
 `Barn ${i+1}: ${b.fornavn} ${b.efternavn}${b.cpr?" (CPR: "+b.cpr+")":""}${b.forældremyndighed?" · Forældremyndighed: "+b.forældremyndighed:""}${b.bopæl?" · Bopæl: "+b.bopæl:""}`
 ).join("\n");
 const eksist_boern_h = eksisterende_h.find(h => h.titel === "Børneoplysninger (GDPR niveau 2)");
 if (eksist_boern_h) {
 await api("haendelser/" + eksist_boern_h.id, "PATCH", { beskrivelse: boern_tekst }).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); });
 } else {
 await api("haendelser", "POST", { sag_id: String(redigering.sag_id), type:"note", titel:"Børneoplysninger (GDPR niveau 2)", beskrivelse:boern_tekst }).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); });
 }
 }
 setSagsnummer(redigering.sagsnummer);
 setOprettet(true);
 setGemmer(false);
 return;
 }
 // ── NY KLIENT: POST ──
 const klient_res = await api("klienter", "POST", {
 fornavn: klient.fornavn.trim(), efternavn: klient.efternavn.trim(),
 cpr: klient.cpr, telefon: klient.telefon, email: klient.email,
 adresse: klient.adresse, postnr: klient.postnr, by: klient.by,
 manuelt_sagsnummer: sag.manuelt_nr ? sag.manuelt_nr.trim() : null,
 });
 if (!klient_res || klient_res.fejl) {
 toast("Fejl ved oprettelse: " + (klient_res ? klient_res.fejl : "Serverfejl"), "fejl");
 setGemmer(false); return;
 }
 const sag_res = await api("sager", "POST", {
 klient_id: klient_res.klient.id, type: sag.type,
 klient_maal: sag.klient_maal, aftaler: sag.honorar, status: er_lead_type(sag.type) ? 'lead' : 'aktiv',
 primær_sagsbehandler_id: sag.primær_id || null,
 });
 // ALTID: Opret sagsopstart som første hændelse
 const sag_id_ny = sag_res?.sag?.id || sag_res?.id;
 if (sag_id_ny) {
 await api("haendelser", "POST", {
 sag_id: String(sag_id_ny),
 type: "note",
 titel: "Oprettelse af sag",
 beskrivelse: noter.opstart || "Sag oprettet.",
 begivenhedsdato: new Date().toISOString().split("T")[0],
 }).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); });
 // Klientens mål — gem som separat hændelse så det altid er synligt
 if (sag.klient_maal) {
 await api("haendelser", "POST", {
 sag_id: String(sag_id_ny),
 type: "note",
 titel: "Klientens mål",
 beskrivelse: sag.klient_maal,
 begivenhedsdato: new Date().toISOString().split("T")[0],
 }).catch(err => console.error(err));
 }
 // Aftaler/honorar — gem som separat hændelse
 if (sag.honorar) {
 await api("haendelser", "POST", {
 sag_id: String(sag_id_ny),
 type: "note",
 titel: "Aftaler og honorar",
 beskrivelse: sag.honorar,
 begivenhedsdato: new Date().toISOString().split("T")[0],
 }).catch(err => console.error(err));
 }
 // Vigtige datoer — gem som separat hændelse (ikke duplikeret i strategi)
 if (noter.vigtige_datoer) {
 await api("haendelser", "POST", {
 sag_id: String(sag_id_ny),
 type: "note",
 titel: "Vigtige datoer",
 beskrivelse: noter.vigtige_datoer,
 begivenhedsdato: new Date().toISOString().split("T")[0],
 }).catch(err => console.error(err));
 }
 }
 // Gem modpart som hændelse hvis angivet
 if (sag_id_ny && (modpart.fornavn || modpart.efternavn)) {
 const modpart_tekst = [
 modpart.fornavn && modpart.efternavn ? modpart.fornavn+" "+modpart.efternavn : modpart.fornavn || modpart.efternavn,
 modpart.email ? "Email: "+modpart.email : null,
 modpart.telefon ? "Tlf: "+modpart.telefon : null,
 modpart.adresse ? "Adresse: "+[modpart.adresse,modpart.postnr,modpart.by].filter(Boolean).join(" ") : null,
 modpart.advokat ? "Advokat: "+modpart.advokat : null,
 ].filter(Boolean).join("\n");
 await api("haendelser", "POST", {
 sag_id: String(sag_id_ny),
 type: "note",
 titel: "Modpartoplysninger",
 beskrivelse: modpart_tekst,
 }).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); });
 }
 // Gem børn i database OG som hændelse
 if (sag_id_ny && boern.length > 0) {
 const boern_db_res = await api("sager/" + sag_id_ny + "/boern", "POST", { boern }).catch(err => { console.error('[BOERN] POST fejl:', err); return null; });
 if (!boern_db_res || boern_db_res.fejl) {
 // BOERN-TOLERANT: Tidligere blev denne fejl svalget lydløst så børn aldrig kom i DB
 toast(" Børn kunne ikke gemmes i database — kun som note. " + (boern_db_res?.fejl || "Prøv at redigere klienten igen"), "fejl");
 } else if (boern_db_res.advarsler?.length) {
 toast("Børn gemt med advarsler: " + boern_db_res.advarsler.join("; "), "advarsel");
 }
 // Gem DB-IDs på børnene så fuldmagt-dialogen kan bruge dem
 if (boern_db_res?.boern) {
 boern_db_res.boern.forEach((db_barn, i) => {
 if (boern[i]) boern[i].db_id = db_barn.id;
 });
 }
 const boern_tekst = boern.map((b,i) =>
 `Barn ${i+1}: ${b.fornavn} ${b.efternavn}${b.cpr?" (CPR: "+b.cpr+")":""}${b.forældremyndighed?" · Forældremyndighed: "+b.forældremyndighed:""}${b.bopæl?" · Bopæl: "+b.bopæl:""}`
 ).join("\n");
 await api("haendelser", "POST", {
 sag_id: String(sag_id_ny),
 type: "note",
 titel: "Børneoplysninger (GDPR niveau 2)",
 beskrivelse: boern_tekst,
 }).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); });
 }
 // Gem strategi-noter hvis angivet (vigtige_datoer er gemt som separat hændelse ovenfor)
 if (sag_id_ny && noter.strategi) {
 await api("haendelser", "POST", {
 sag_id: String(sag_id_ny),
 type: "note",
 titel: "Strategi og vigtige bemærkninger",
 beskrivelse: noter.strategi,
 begivenhedsdato: new Date().toISOString().split("T")[0],
 }).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); });
 }
 const nr = klient_res.klient.sagsnummer || "SV-????";
 // Opret OneDrive mappestruktur automatisk
 if (nr && nr !== "SV-????") {
 api("onedrive/opret-klient", "POST", {
 klient_navn: klient.fornavn.trim() + " " + klient.efternavn.trim(),
 sagsnummer: nr,
 }).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); }); // Fejl må ikke stoppe oprettelsen
 }
 setSagsnummer(nr);
 setOprettetSagId(sag_id_ny);
 setOprettetKlientId(klient_res.klient.id);
 setOprettet(true);
 // U2: Ryd draft efter succesfuld oprettelse
 autoSaveManager.slet('ny-klient-wizard');
 // Vis fuldmagt-spørgsmål (virker både med og uden børn — uden børn
 // kræver dog en "Fuldmagt_voksen.dotx" skabelon som kommer senere)
 setFuldmagtTrin('spørg');
 setGemmer(false);
 } catch(err) {
 toast("Klient kunne ikke oprettes — prøv igen", "fejl"); console.error("[WIZARD] opret fejl:", err);
 setGemmer(false);
 }
 };
 const tilfoej_barn = () => setBoern(p=>[...p,{id:Date.now(),fornavn:"",efternavn:"",cpr:"",forældremyndighed:"",bopæl:"",omhandler:""}]);
 const opdater_barn = (id,felt,val) => setBoern(p=>p.map(b=>b.id===id?{...b,[felt]:val}:b));
 const fjern_barn = id => setBoern(p=>p.filter(b=>b.id!==id));
 const generer_fuldmagt = async () => {
 // Tillader tom boern_ids — backend genererer så fuldmagt uden børn
 if (!oprettet_sag_id || !oprettet_klient_id) return;
 setFuldmagtLoading(true);
 try {
 const data = await api("fuldmagt/generer", "POST", {
 sag_id: oprettet_sag_id, klient_id: oprettet_klient_id, boern_ids: fuldmagt_valgte_boern,
 });
 if (!data?.succes) {
 if (data?.mangler_skabelon) toast(" " + data.fejl, "fejl");
 else toast("Fejl: " + (data?.fejl || "Kunne ikke generere fuldmagt"), "fejl");
 setFuldmagtLoading(false); return;
 }
 setFuldmagtPdf(data);
 setFuldmagtTrin('preview');
 } catch (err) {
 toast("Fuldmagt kunne ikke genereres — prøv igen", "fejl"); console.error("[WIZARD] fuldmagt fejl:", err);
 }
 setFuldmagtLoading(false);
 };
 const fuldmagt_download = () => {
 if (!fuldmagt_pdf) return;
 const bytes = atob(fuldmagt_pdf.pdf_base64);
 const arr = new Uint8Array(bytes.length);
 for (let i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i);
 const blob = new Blob([arr], { type: fuldmagt_pdf.mime_type });
 const url = window.URL.createObjectURL(blob);
 const a = document.createElement("a");
 a.href = url; a.download = fuldmagt_pdf.filnavn || "Fuldmagt.pdf";
 document.body.appendChild(a); a.click(); a.remove();
 window.URL.revokeObjectURL(url);
 };
 const fuldmagt_print = () => {
 if (!fuldmagt_pdf) return;
 const bytes = atob(fuldmagt_pdf.pdf_base64);
 const arr = new Uint8Array(bytes.length);
 for (let i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i);
 const blob = new Blob([arr], { type: 'application/pdf' });
 const url = window.URL.createObjectURL(blob);
 const win = window.open(url);
 if (win) win.onload = () => { win.print(); };
 };
 if (oprettet) return (
 <div style={{ minHeight:"100vh", background:BG, display:"flex", alignItems:"center", justifyContent:"center", padding:24 }}> <Glas style={{ padding: fuldmagt_trin === 'preview' ? "20px 24px" : 40, textAlign:"center", maxWidth: fuldmagt_trin === 'preview' ? "95vw" : 440, width: fuldmagt_trin === 'preview' ? "95vw" : "auto", animation:"fadeUp 0.5s ease", transition:"all 0.3s ease" }}> <div style={{ position:"relative", width:88, height:88, margin:"0 auto 28px" }}>
 {/* Burst rings */}
 <div style={{ position:"absolute", inset:-12, borderRadius:"50%", border:`1.5px solid ${T.turkis}22`, animation:"sv-ring-out 2s ease-in-out infinite" }} /> <div style={{ position:"absolute", inset:-6, borderRadius:"50%", border:`1.5px solid ${T.turkis}33`, animation:"sv-ring-out 2s ease-in-out infinite 0.35s" }} /> <div style={{ width:88, height:88, borderRadius:"50%",
 background:`radial-gradient(circle at 35% 35%, ${T.turkis}28, ${T.turkis}08)`,
 border:`2px solid ${T.turkis}`,
 boxShadow:`0 0 32px ${T.turkis}40, inset 0 1px 0 rgba(255,255,255,0.15)`,
 display:"flex", alignItems:"center", justifyContent:"center",
 fontSize:34, animation:"sv-check-pop 0.55s cubic-bezier(0.34,1.56,0.64,1) both",
 }}></div> </div> <div style={{ fontFamily:"DM Mono, monospace", fontSize:12, color:T.dæmpet, letterSpacing:"0.2em", textTransform:"uppercase", marginBottom:8 }}>Sag oprettet</div> <div style={{ fontSize:32, fontWeight:300, color:T.turkis, fontFamily:"DM Mono, monospace", letterSpacing:"0.05em", marginBottom:4 }}>{sagsnummer}</div> <div style={{ color:T.lys, marginBottom:6 }}>{klient.fornavn} {klient.efternavn}</div> <div style={{ color:T.dæmpet, fontSize:12, marginBottom: boern.length>0?12:24 }}>{SAGSTYPER.find(x=>x.v===sag.type)?.l}</div>
 {boern.length>0 && <div style={{ color:T.lilla, fontSize:12, marginBottom:24 }}> GDPR niveau 2 · {boern.length} {boern.length===1?"barn":"børn"}</div>}
 {/* ── FULDMAGT-DIALOG ── */}
 {fuldmagt_trin === 'spørg' && (
 <div style={{ background:"rgba(63,212,199,0.06)", border:`1px solid ${T.turkis}33`, borderRadius:12, padding:"20px", marginBottom:20, textAlign:"left" }}> <div style={{ fontSize:14, fontWeight:600, color:T.creme, marginBottom:12, textAlign:"center" }}>Skal der oprettes fuldmagt?</div> <div style={{ display:"flex", gap:10 }}> <button onClick={() => { setFuldmagtValgteBoern(boern.map(b => b.db_id || b.id)); setFuldmagtTrin('vælg_børn'); }}
 style={{ flex:1, padding:"12px", borderRadius:8, border:`2px solid ${T.turkis}`, background:T.turkis+"18", color:T.turkis, fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Ja, opret fuldmagt
 </button> <button onClick={() => setFuldmagtTrin(null)}
 style={{ flex:1, padding:"12px", borderRadius:8, border:"2px solid rgba(255,255,255,0.15)", background:"transparent", color:T.dæmpet, fontSize:14, fontWeight:600, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Ikke nu
 </button> </div> <div style={{ fontSize:12, color:T.dæmpet, marginTop:10, textAlign:"center" }}>Kan altid oprettes senere fra klientens overblik</div> </div>
 )}
 {fuldmagt_trin === 'vælg_børn' && (
 <div style={{ background:"rgba(63,212,199,0.06)", border:`1px solid ${T.turkis}33`, borderRadius:12, padding:"20px", marginBottom:20, textAlign:"left" }}> <div style={{ fontSize:14, fontWeight:600, color:T.creme, marginBottom:6, textAlign:"center" }}>
 {boern.length === 0 ? "Fuldmagt uden børn" : "Vælg børn til fuldmagten"}
 </div>
 {boern.length === 0 ? (
 <div style={{ fontSize:12, color:"#ffd166", textAlign:"center", marginBottom:14, padding:"10px 12px", background:"rgba(255,209,102,0.08)", border:"1px solid rgba(255,209,102,0.25)", borderRadius:8 }}>
 Ingen børn registreret — fuldmagten oprettes kun for klienten selv (voksen).
 </div>
 ) : (
 <> <div style={{ fontSize:11, color:T.dæmpet, textAlign:"center", marginBottom:12 }}>
 Fravælg alle hvis fuldmagten kun skal dække klienten (voksen).
 </div>
 {boern.map(b => {
 const bid = b.db_id || b.id;
 const valgt = fuldmagt_valgte_boern.includes(bid);
 return (
 <div key={bid} onClick={() => setFuldmagtValgteBoern(prev => valgt ? prev.filter(x=>x!==bid) : [...prev, bid])}
 style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 12px", borderRadius:8, marginBottom:6, cursor:"pointer", background: valgt ? "rgba(63,212,199,0.12)" : "rgba(255,255,255,0.04)", border:`1px solid ${valgt ? T.turkis+"44" : "rgba(255,255,255,0.08)"}`, transition:"all 0.15s" }}> <div style={{ width:20, height:20, borderRadius:5, border:`2px solid ${valgt ? T.turkis : "rgba(255,255,255,0.25)"}`, background:valgt ? T.turkis : "transparent", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
 {valgt && <span style={{ color:"#fff", fontSize:12, fontWeight:700 }}></span>}
 </div> <div style={{ fontSize:13, color:T.creme }}>{b.fornavn} {b.efternavn}</div> </div>
 );
 })}
 </>
 )}
 <div style={{ display:"flex", gap:10, marginTop:14 }}> <button onClick={generer_fuldmagt} disabled={fuldmagt_loading}
 style={{ flex:1, padding:"12px", borderRadius:8, border:"none", background: fuldmagt_loading ? "rgba(63,212,199,0.4)" : T.turkis, color:"#fff", fontSize:14, fontWeight:700, cursor: fuldmagt_loading ? "not-allowed" : "pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 {fuldmagt_loading ? " Genererer..."
 : fuldmagt_valgte_boern.length === 0
 ? " Generér fuldmagt (uden børn)"
 : ` Generér fuldmagt (${fuldmagt_valgte_boern.length} ${fuldmagt_valgte_boern.length===1?"barn":"børn"})`}
 </button> <button onClick={() => setFuldmagtTrin(null)}
 style={{ padding:"12px 16px", borderRadius:8, border:T.skillelinje, background:"transparent", color:T.dæmpet, fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Spring over
 </button> </div> </div>
 )}
 {fuldmagt_trin === 'preview' && fuldmagt_pdf && (
 <div style={{ background:"rgba(63,212,199,0.06)", border:`1px solid ${T.turkis}33`, borderRadius:12, padding:"20px", marginBottom:20 }}> <div style={{ fontSize:14, fontWeight:600, color:T.creme, marginBottom:12, textAlign:"center" }}>
 Fuldmagt genereret — {fuldmagt_pdf.klient_navn}
 </div> <div style={{ fontSize:12, color:T.dæmpet, textAlign:"center", marginBottom:14 }}>
 Gemt i hændelser og OneDrive · Status: Afventer underskrift
 </div>
 {/* PDF Preview — fyldt størrelse for læsbarhed */}
 <div style={{ borderRadius:8, overflow:"hidden", marginBottom:16, background:"#fff", border:"1px solid rgba(0,0,0,0.1)" }}> <iframe
 src={`data:application/pdf;base64,${fuldmagt_pdf.pdf_base64}`}
 style={{ width:"100%", height:"82vh", minHeight:700, border:"none" }}
 title="Fuldmagt preview"
 /> </div>
 {/* Handlingsknapper */}
 <div className="sv-form-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}> <button onClick={fuldmagt_download}
 style={{ padding:"12px", borderRadius:8, border:`1px solid ${T.turkis}44`, background:T.turkis+"12", color:T.turkis, fontSize:13, fontWeight:600, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif", display:"flex", alignItems:"center", justifyContent:"center", gap:6 }}>
 Download
 </button> <button onClick={fuldmagt_print}
 style={{ padding:"12px", borderRadius:8, border:`1px solid ${T.turkis}44`, background:T.turkis+"12", color:T.turkis, fontSize:13, fontWeight:600, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif", display:"flex", alignItems:"center", justifyContent:"center", gap:6 }}>
 Udskriv
 </button> </div> <div style={{ display:"flex", gap:8, marginTop:8 }}> <button onClick={() => { setFuldmagtValgteBoern(boern.map(b => b.db_id || b.id)); setFuldmagtPdf(null); setFuldmagtTrin('vælg_børn'); }}
 style={{ flex:1, padding:"10px", borderRadius:8, border:T.skillelinje, background:"transparent", color:T.dæmpet, fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 ↻ Generér igen
 </button> <button onClick={() => setFuldmagtTrin(null)}
 style={{ flex:1, padding:"10px", borderRadius:8, border:T.skillelinje, background:"transparent", color:T.dæmpet, fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Luk
 </button> </div> </div>
 )}
 <Knap onClick={onFærdig} style={{ width:"100%" }}>Åbn sagen →</Knap> </Glas> </div>
 );
 const aktiv_meta = TRIN_META.find(t=>t.id===aktivt);
 return (
 <> <div className="sv-wizard" style={{ display:"flex", flexDirection:"column" }}>
 {/* Kontekst-bar */}
 <div style={{ padding:"10px 20px", borderBottom:T.skillelinje, display:"flex", alignItems:"center", justifyContent:"space-between" }}> <span style={{ fontSize:13, color:"#cbd5e1" }}>{redigering ? "Rediger klient · " + redigering.sagsnummer : "Opret ny klient og sag"}</span> <Knap onClick={onAnnuller} variant="ghost" style={{ padding:"8px 14px", fontSize:12 }}>Annuller</Knap> </div>
 {/* Trin-navigation — fri hopping */}
 <div style={{ borderBottom:T.skillelinje }}> <TrinNavigation aktivt={aktivt} setAktivt={setAktivt} status={status} /> </div>
 {/* Indhold */}
 <div style={{ flex:1, overflowY:"auto", padding:"clamp(20px, 4vw, 48px) clamp(16px, 5vw, 48px) 20px" }}> <div style={{ maxWidth:"min(680px, 100%)", margin:"0 auto" }}>
 {/* Sektion titel */}
 <div style={{ display:"flex", alignItems:"center", gap:14, marginBottom:28 }}> <div style={{ position:"relative", width:52, height:52, borderRadius:16, background:`linear-gradient(135deg, ${aktiv_meta?.farve}22 0%, ${aktiv_meta?.farve}08 100%)`, border:`1px solid ${aktiv_meta?.farve}44`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:22, flexShrink:0, boxShadow:`0 0 24px ${aktiv_meta?.farve}25` }}> <div style={{ position:"absolute", inset:0, borderRadius:16, background:`radial-gradient(circle at 30% 30%, ${aktiv_meta?.farve}18 0%, transparent 70%)`, pointerEvents:"none" }} />
 {aktiv_meta?.ikon}
 </div> <div> <div style={{ fontSize:"clamp(18px, 2vw, 24px)", fontWeight:700, letterSpacing:"-0.02em", background:`linear-gradient(90deg, #f1f5f9, ${aktiv_meta?.farve})`, WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", backgroundClip:"text" }}>{aktiv_meta?.label}</div> <div style={{ fontSize:"clamp(12px, 1.1vw, 13px)", color:T.dæmpet, marginTop:3 }}>
 {{ klient:"Obligatoriske oplysninger om klienten", sag:"Sagstype og klientens mål", modpart:"Alle felter er valgfrie — kan udfyldes og ændres løbende", boern:"Involverede børn — GDPR niveau 2 aktiveres", noter:"Alle felter er valgfrie — kan udfyldes og redigeres løbende", bekræft:"Gennemse og opret sagen" }[aktivt]}
 </div> </div> </div>
 {/* ── TRIN: KLIENT ── */}
 {aktivt==="klient" && (
 <Glas style={{ padding:"clamp(20px, 3vw, 36px)", animation:"sv-panel-enter 0.4s cubic-bezier(0.34,1.56,0.64,1) both" }}> <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(200px, 1fr))", gap:"0 16px" }}> <div> <Label req>Fornavn</Label> <Input value={klient.fornavn} onChange={k("fornavn")} onBlur={e=>valider_felt("fornavn",e.target.value)} placeholder="Fornavn" fejl={fejl.fornavn} /> </div> <div> <Label req>Efternavn</Label> <Input value={klient.efternavn} onChange={k("efternavn")} onBlur={e=>valider_felt("efternavn",e.target.value)} placeholder="Efternavn" fejl={fejl.efternavn} /> </div> </div> <Label valgfri>CPR-nummer <HjaelpIkon tekst="CPR-nummer krypteres automatisk (AES-256-GCM) før det gemmes i databasen. Kun brugere med rettighed 'Se CPR-numre' kan se det dekrypteret. Format: DDMMÅÅ-XXXX. Modulus 11-validering er advisory (efter 2007 kan CPR være gyldige uden)." /></Label> <CprFelt value={klient.cpr} onChange={v=>setKlient(p=>({...p,cpr:v}))} fejl={fejl.cpr} /> <Label req>Mobilnummer <HjaelpIkon tekst="Automatisk journalisering: Når systemet modtager opkald fra dette nummer vises en popup der kan notere opkaldet direkte på sagen. Tidspunkt og varighed gemmes." /></Label> <Input value={klient.telefon} onChange={k("telefon")} onBlur={e=>valider_felt("telefon",e.target.value)} placeholder="+45 XX XX XX XX" type="tel" fejl={fejl.telefon} /> <Label valgfri>Email <HjaelpIkon tekst="Automatisk mail-journalisering: Mails til/fra denne adresse journaliseres automatisk på sagen som hændelser. Gælder alle 8 overvågede postkasser." /></Label> <Input value={klient.email} onChange={k("email")} placeholder="email@eksempel.dk" type="email" /> <Label req>Adresse</Label> <Input value={klient.adresse} onChange={k("adresse")} onBlur={e=>valider_felt("adresse",e.target.value)} placeholder="Vejnavn og husnummer" fejl={fejl.adresse} /> <PostnrBy postnr={klient.postnr} by={klient.by} setPostnr={v=>setKlient(p=>({...p,postnr:v}))} setBy={v=>setKlient(p=>({...p,by:v}))} />
 {(fejl.postnr||fejl.by) && <div style={{color:T.roed,fontSize:12,marginTop:-10,marginBottom:12}}>Postnr. og by er påkrævet</div>}
 {/* V1.3.1: Alternative kontakt-adresser (kun synlig ved rediger-mode — ny klient får det efter første POST) */}
 {redigering?.klient_id && (
 <div style={{ marginTop:14 }}> <KlientKontakterPanel
 klient_id={redigering.klient_id}
 klient_primaer_email={klient.email}
 klient_primaer_telefon={klient.telefon}
 compact={false}
 /> </div>
 )}
 {/* Fuldmagt håndteres efter oprettelse i success-dialogen */}
 </Glas>
 )}
 {/* ── TRIN: SAG ── */}
 {aktivt==="sag" && (
 <Glas style={{ padding:24, animation:"sv-panel-enter 0.4s cubic-bezier(0.34,1.56,0.64,1) both" }}> <Label req>Sagstype</Label> <Select value={sag.type} onChange={s("type")} options={sagstype_options} fejl={fejl.type} /> <Label req>Hvad ønsker klienten?</Label> <Textarea value={sag.klient_maal} onChange={s("klient_maal")} onBlur={e=>valider_felt("klient_maal",e.target.value)} placeholder="Beskriv kort klientens mål — fx 'bopæl hos mor', 'delt samvær', 'skilsmisse inden sommer'..." rows={3} visCount={true} maxLength={500} />
 {fejl.klient_maal && <div style={{color:T.roed,fontSize:12,marginTop:2,marginBottom:12}}>{fejl.klient_maal}</div>}
 {!er_lead_type(sag.type) && (<><Label req>Primær sagsbehandler</Label> <div style={{ display:"flex", flexWrap:"wrap", gap:6, marginBottom:16 }}>
 {ny_klient_brugere.map(b => (
 <button key={b.id} onClick={() => setSag(p => ({...p, primær_id: String(b.id), primær_navn: b.navn}))}
 style={{ padding:"8px 14px", borderRadius:8, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", cursor:"pointer",
 border:`2px solid ${sag.primær_id === String(b.id) ? T.turkis : "rgba(255,255,255,0.08)"}`,
 background: sag.primær_id === String(b.id) ? `${T.turkis}18` : "rgba(255,255,255,0.04)",
 color: sag.primær_id === String(b.id) ? T.turkis : T.dæmpet,
 fontWeight: sag.primær_id === String(b.id) ? 700 : 400,
 }}>
 {b.navn}
 </button>
 ))}
 </div>
 {fejl.primær && <div style={{color:T.roed,fontSize:12,marginTop:-10,marginBottom:12}}>{fejl.primær}</div>}</>)}
 <Label valgfri>Aftaler</Label> <Input value={sag.honorar} onChange={s("honorar")} placeholder="Beskriv aftaler om honorar, betalingsplan, fri rådgivning..." type="text" /> </Glas>
 )}
 {/* ── TRIN: MODPART ── */}
 {aktivt==="modpart" && (
 <Glas style={{ padding:24, animation:"sv-panel-enter 0.4s cubic-bezier(0.34,1.56,0.64,1) both" }}> <div style={{ padding:"10px 14px", background:"rgba(255,209,102,0.06)", border:"1px solid rgba(255,209,102,0.2)", borderRadius:8, marginBottom:20 }}> <div style={{ fontSize:12, color:T.gul }}>Alle felter er valgfrie — kan tilføjes og ændres løbende</div> </div> <div className="sv-form-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 14px" }}> <div><Label>Fornavn</Label><Input value={modpart.fornavn} onChange={m("fornavn")} placeholder="Fornavn" /></div> <div><Label>Efternavn</Label><Input value={modpart.efternavn} onChange={m("efternavn")} placeholder="Efternavn" /></div> </div> <Label>Email</Label> <Input value={modpart.email} onChange={m("email")} placeholder="email@eksempel.dk" type="email" /> <Label>Telefon</Label> <Input value={modpart.telefon} onChange={m("telefon")} placeholder="+45 XX XX XX XX" type="tel" /> <Label>Adresse</Label> <Input value={modpart.adresse} onChange={m("adresse")} placeholder="Vejnavn og husnummer" /> <PostnrBy postnr={modpart.postnr} by={modpart.by} setPostnr={v=>setModpart(p=>({...p,postnr:v}))} setBy={v=>setModpart(p=>({...p,by:v}))} /> <Label>Advokat</Label> <Input value={modpart.advokat} onChange={m("advokat")} placeholder="Navn på modparts advokat" /> </Glas>
 )}
 {/* ── TRIN: BØRN ── */}
 {aktivt==="boern" && (
 <div style={{ animation:"sv-panel-enter 0.4s cubic-bezier(0.34,1.56,0.64,1) both" }}>
 {boern.length===0 && (
 <Glas style={{ padding:32, textAlign:"center", marginBottom:16 }}> <div style={{ fontSize:36, marginBottom:12 }}></div> <div style={{ color:T.lys, fontSize:14, marginBottom:6 }}>Ingen børn registreret</div> <div style={{ color:T.dæmpet, fontSize:12, marginBottom:20 }}>Tilføj involverede børn — sagen markeres automatisk som GDPR niveau 2</div> <Knap onClick={tilfoej_barn} style={{ width:"100%" }}>+ Tilføj barn</Knap> </Glas>
 )}
 {boern.map((b,idx)=>(
 <Glas key={b.id} style={{ padding:20, marginBottom:14 }}> <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:18 }}> <div style={{ display:"flex", alignItems:"center", gap:10 }}> <div style={{ width:28, height:28, borderRadius:"50%", background:`${T.lilla}22`, border:`1px solid ${T.lilla}44`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:13, color:T.lilla }}>
 {idx+1}
 </div> <span style={{ fontSize:13, color:T.lys, fontWeight:500 }}>Barn {idx+1}</span> </div> <button onClick={()=>fjern_barn(b.id)} style={{ background:"none", border:`1px solid ${T.roed}33`, borderRadius:6, padding:"4px 10px", color:T.roed, fontSize:12 }}>Fjern</button> </div> <div className="sv-form-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 14px" }}> <div><Label req>Fornavn</Label><Input value={b.fornavn} onChange={e=>opdater_barn(b.id,"fornavn",e.target.value)} placeholder="Fornavn" /></div> <div><Label req>Efternavn</Label><Input value={b.efternavn} onChange={e=>opdater_barn(b.id,"efternavn",e.target.value)} placeholder="Efternavn" /></div> </div> <Label req>CPR-nummer</Label> <CprFelt value={b.cpr} onChange={v=>opdater_barn(b.id,"cpr",v)} /> <div className="sv-form-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 14px" }}> <div> <Label req>Forældremyndighed</Label> <Select value={b.forældremyndighed} onChange={e=>opdater_barn(b.id,"forældremyndighed",e.target.value)} options={FORÆLDREMY} /> </div> <div> <Label req>Nuværende bopæl</Label> <Select value={b.bopæl} onChange={e=>opdater_barn(b.id,"bopæl",e.target.value)} options={BOPÆL_OPT} /> </div> </div> <Label>Hvad omhandler sagen ift. dette barn?</Label> <Textarea value={b.omhandler} onChange={e=>opdater_barn(b.id,"omhandler",e.target.value)} placeholder="fx klienten ønsker fuld forældremyndighed..." rows={2} /> </Glas>
 ))}
 {boern.length>0 && (
 <button onClick={tilfoej_barn} style={{ width:"100%", background:"none", border:"1px dashed rgba(255,255,255,0.06)", borderRadius:10, padding:"14px", color:T.dæmpet, fontSize:13, transition:"all 0.2s" }}
 onMouseOver={e=>{e.currentTarget.style.borderColor=T.lilla+"66";e.currentTarget.style.color=T.lilla}}
 onMouseOut={e=>{e.currentTarget.style.borderColor="rgba(255,255,255,0.06)";e.currentTarget.style.color=T.dæmpet}}>
 + Tilføj endnu et barn
 </button>
 )}
 </div>
 )}
 {/* ── TRIN: NOTER ── */}
 {aktivt==="noter" && (
 <Glas style={{ padding:24, animation:"sv-panel-enter 0.4s cubic-bezier(0.34,1.56,0.64,1) both" }}> <Label>Opstartsnotat</Label> <Textarea value={noter.opstart} onChange={n("opstart")} placeholder="Fri tekst — hvad kom frem i den indledende samtale? Baggrund, bekymringer, følelser, ønsker..." rows={5} /> <Label>Vigtige datoer og frister</Label> <Textarea value={noter.vigtige_datoer} onChange={n("vigtige_datoer")} placeholder="fx: skilsmisse indgået 12/3, børnene starter nyt skoleår august, møde med Familieretshuset aftalt..." rows={3} /> <Label>Indledende strategi</Label> <Textarea value={noter.strategi} onChange={n("strategi")} placeholder="Første tanker om strategi og tilgang — hvad er de vigtigste prioriteter?" rows={3} /> <Label>Vedhæft filer til opstartsnotat</Label> <Filer filer={noter.filer} onChange={v=>setNoter(p=>({...p,filer:v}))} /> <div style={{ fontSize:12, color:T.dæmpet, marginTop:12 }}>Alt journaliseres automatisk som første hændelse på sagen</div> </Glas>
 )}
 {/* ── TRIN: BEKRÆFT ── */}
 {aktivt==="bekræft" && (
 <div style={{ animation:"sv-panel-enter 0.4s cubic-bezier(0.34,1.56,0.64,1) both" }}>
 {Object.keys(fejl).length>0 && (
 <div style={{ background:"rgba(255,107,107,0.08)", border:`1px solid ${T.roed}33`, borderRadius:10, padding:"14px 18px", marginBottom:16 }}> <div style={{ color:T.roed, fontSize:13, fontWeight:500, marginBottom:6 }}>Manglende obligatoriske felter</div> <div style={{ color:"rgba(255,107,107,0.8)", fontSize:12 }}>
 {Object.entries(fejl).map(([k,v])=><div key={k}>· {v} ({k})</div>)}
 </div> </div>
 )}
 <Glas style={{ padding:20, marginBottom:14 }}> <div style={{ fontSize:12, color:T.turkis, letterSpacing:"0.2em", textTransform:"uppercase", marginBottom:14 }}>Klient</div>
 {[[`${klient.fornavn} ${klient.efternavn}`,"Navn"],[klient.cpr.slice(0,6)+"-****","CPR"],[klient.telefon,"Telefon"],[klient.email,"Email"],[`${klient.adresse}, ${klient.postnr} ${klient.by}`,"Adresse"]].filter(([v])=>v.trim()).map(([v,l])=>(
 <div key={l} style={{ display:"flex", justifyContent:"space-between", padding:"7px 0", borderBottom:T.skillelinje, fontSize:12 }}> <span style={{ color:T.dæmpet }}>{l}</span> <span style={{ color:T.creme, textAlign:"right", maxWidth:"60%" }}>{v}</span> </div>
 ))}
 </Glas> <Glas style={{ padding:20, marginBottom:14 }}> <div style={{ fontSize:12, color:"#60a5fa", letterSpacing:"0.2em", textTransform:"uppercase", marginBottom:14 }}>Sag</div>
 {[[SAGSTYPER.find(x=>x.v===sag.type)?.l||"—","Type"],[sag.klient_maal,"Klientens mål"],[sag.honorar,"Aftaler"]].filter(([v])=>v&&v!=="—").map(([v,l])=>(
 <div key={l} style={{ display:"flex", justifyContent:"space-between", padding:"7px 0", borderBottom:T.skillelinje, fontSize:12 }}> <span style={{ color:T.dæmpet }}>{l}</span> <span style={{ color:T.creme, textAlign:"right", maxWidth:"65%" }}>{v}</span> </div>
 ))}
 </Glas>
 {(modpart.fornavn||modpart.efternavn) && (
 <Glas style={{ padding:20, marginBottom:14 }}> <div style={{ fontSize:12, color:T.gul, letterSpacing:"0.2em", textTransform:"uppercase", marginBottom:14 }}>Modpart</div> <div style={{ fontSize:12, color:T.creme }}>{`${modpart.fornavn} ${modpart.efternavn}`.trim()}</div> </Glas>
 )}
 {boern.length>0 && (
 <Glas style={{ padding:20, marginBottom:14 }}> <div style={{ fontSize:12, color:T.lilla, letterSpacing:"0.2em", textTransform:"uppercase", marginBottom:14 }}>Børn ({boern.length}) — GDPR niveau 2</div>
 {boern.map((b,i)=>(
 <div key={b.id} style={{ fontSize:12, color:T.lys, padding:"6px 0", borderBottom:i<boern.length-1?T.skillelinje:"none" }}>
 {b.fornavn} {b.efternavn} · {FORÆLDREMY.find(x=>x.v===b.forældremyndighed)?.l||"—"}
 </div>
 ))}
 </Glas>
 )}
 {noter.opstart && (
 <Glas style={{ padding:20, marginBottom:14 }}> <div style={{ fontSize:12, color:T.groen, letterSpacing:"0.2em", textTransform:"uppercase", marginBottom:10 }}>Opstartsnotat</div> <div style={{ fontSize:12, color:T.lys, lineHeight:1.7 }}>{noter.opstart.slice(0,200)}{noter.opstart.length>200?"...":""}</div> </Glas>
 )}
 <Knap onClick={opret} disabled={gemmer} style={{ width:"100%", padding:"15px", fontSize:14, marginTop:8 }}>
 {gemmer ? "Gemmer…" : (redigering ? " Gem ændringer" : " Opret klient og sag")}
 </Knap> </div>
 )}
 </div> </div>
 {/* Footer navigation */}
 <div style={{ padding:"14px 20px", borderTop:T.skillelinje, display:"flex", justifyContent:"space-between", alignItems:"center" }}> <div style={{ fontSize:12, color:T.subtil }}>
 {Object.values(status).filter(Boolean).length} af {TRIN_META.length-1} trin udfyldt
 </div> <div style={{ display:"flex", gap:10 }}>
 {aktivt!=="klient" && (
 <Knap variant="sekundær" onClick={()=>{ const idx=TRIN_META.findIndex(t=>t.id===aktivt); if(idx>0) setAktivt(TRIN_META[idx-1].id); }} style={{ padding:"10px 18px" }}>
 ← Forrige
 </Knap>
 )}
 {aktivt!=="bekræft" && (
 <Knap onClick={()=>{ const idx=TRIN_META.findIndex(t=>t.id===aktivt); if(idx<TRIN_META.length-1) setAktivt(TRIN_META[idx+1].id); }} style={{ padding:"10px 18px" }}>
 Næste →
 </Knap>
 )}
 {aktivt==="bekræft" && (
 <Knap onClick={opret} disabled={gemmer} style={{ padding:"10px 22px" }}>{gemmer ? "Gemmer…" : (redigering ? " Gem" : " Opret")}</Knap>
 )}
 </div> </div> </div>
 {bekræft_slet_kladde && (
 <BekræftDialog
 besked="Slet kladde? Alle ugemte oplysninger slettes permanent."
 onJa={() => {
 autoSaveManager.slet('ny-klient-wizard');
 setKlient({ fornavn:"",efternavn:"",cpr:"",telefon:"",email:"",adresse:"",postnr:"",by:"" });
 setSag(p => ({ ...p, type:"",klient_maal:"",honorar:"",vis_manuelt_nr:false,manuelt_nr:"" }));
 toast('Kladde slettet', 'success');
 setBekræftSletKladde(false);
 }}
 onNej={() => setBekræftSletKladde(false)}
 />
 )}
 </>
 );
}
// ═════════════════════════════════════════════════════════════════════
// V1.3.0: KLIENT-KONTAKTER PANEL
// Admin af alternative emails og telefonnumre for en klient.
// Primær email/tlf er på klienten selv (klienter.email/telefon) — bruges
// til at sende TIL. Alternative gemmes i klient_kontakter-tabellen og
// bruges til journalisering + scanning (mail-import, telefon-lookup).
// ═════════════════════════════════════════════════════════════════════
function KlientKontakterPanel({ klient_id, klient_primaer_email, klient_primaer_telefon, compact = false }) {
 const [kontakter, setKontakter] = useState([]);
 const [indlæser, setIndlæser] = useState(true);
 const [tilføj_type, setTilføjType] = useState("email");
 const [tilføj_vaerdi, setTilføjVaerdi] = useState("");
 const [tilføj_label, setTilføjLabel] = useState("");
 const [tilføj_delt_nummer, setTilføjDeltNummer] = useState(false);
 const [vis_tilføj, setVisTilføj] = useState(false);
 const hent = React.useCallback(() => {
 if (!klient_id) return;
 setIndlæser(true);
 api(`klient-kontakter/klient/${klient_id}`).then(d => {
 setKontakter(d?.kontakter || []);
 setIndlæser(false);
 }).catch(() => setIndlæser(false));
 }, [klient_id]);
 React.useEffect(() => { hent(); }, [hent]);
 const tilføj = async () => {
 const v = tilføj_vaerdi.trim();
 if (!v) return;
 if (tilføj_type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
 toast('Ugyldig email-format', 'fejl'); return;
 }
 const r = await api('klient-kontakter', 'POST', {
 klient_id, type: tilføj_type, vaerdi: v, label: tilføj_label.trim() || null,
 delt_nummer: tilføj_type === 'telefon' ? tilføj_delt_nummer : false,
 });
 if (!r || r.fejl) { toast(r?.fejl || 'Kunne ikke tilføje', 'fejl'); return; }
 toast(`${tilføj_type === 'email' ? 'Email' : 'Telefon'} tilføjet`, 'success');
 setTilføjVaerdi(''); setTilføjLabel(''); setTilføjDeltNummer(false); setVisTilføj(false);
 hent();
 };
 const slet = async (id, label) => {
 const r = await api(`klient-kontakter/${id}`, 'DELETE');
 if (r?.fejl) { toast(r.fejl, 'fejl'); return; }
 toast(`${label || 'Kontakt'} slettet`, 'success');
 hent();
 };
 // v1.11.0: Delt/organisationsnummer — markerer et telefonnummer som fx en
 // Familieretshus-sagsbehandlers eget nummer, der kan være registreret på
 // flere forskellige klienter. Telavox-pipelinen lægger ALTID opkald fra et
 // sådant nummer i opkaldskøen til menneskelig bekræftelse, uanset om kun
 // én sag matcher lige nu (se services/telavox-journalnotat.js/klassificer_kandidater).
 const toggle_delt_nummer = async (kontakt) => {
 const r = await api(`klient-kontakter/${kontakt.id}`, 'PUT', { delt_nummer: !kontakt.delt_nummer });
 if (r?.fejl) { toast(r.fejl, 'fejl'); return; }
 setKontakter(prev => prev.map(k => k.id === kontakt.id ? { ...k, delt_nummer: !kontakt.delt_nummer } : k));
 };
 const emails = kontakter.filter(k => k.type === 'email');
 const tlfer = kontakter.filter(k => k.type === 'telefon');
 const padding = compact ? "10px 12px" : "16px 18px";
 const m_bottom = compact ? 10 : 14;
 const skjul_primaer = compact; // compact: skjul primære så dialog ikke fylder (de er tilgængelige i andre felter)
 return (
 <div style={{ background:"rgba(255,255,255,0.03)", border:T.kort_kant, borderRadius:10, padding, marginBottom:m_bottom }}> <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom: compact ? 8 : 12 }}> <div style={{ fontSize:11, color:T.dæmpet, letterSpacing:"0.08em", textTransform:"uppercase", display:"inline-flex", alignItems:"center", gap:6 }}>
 {compact ? "Alternative kontakt-adresser" : " Kontakt-info"} <HjaelpIkon tekst={compact ? "Alternative emails/telefoner der bruges til automatisk mail-journalisering og opkalds-match. Primær rediger ovenfor." : "Primær email/telefon bruges når vi sender TIL klienten (fx invitationer, fuldmagt). Alternative bruges til automatisk journalisering af indgående mails/opkald og til scan-matching. Tilføj fx arbejdsmail, ægtefælles email osv."} /> </div> <button onClick={() => setVisTilføj(v => !v)}
 style={{ background: vis_tilføj ? "rgba(255,255,255,0.08)" : `${T.turkis}18`, border:`1px solid ${T.turkis}44`, borderRadius:6, padding:"3px 9px", color:T.turkis, fontSize:11, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 {vis_tilføj ? "Annullér" : "+ Tilføj"}
 </button> </div>
 {vis_tilføj && (
 <div style={{ display:"flex", gap:6, marginBottom:12, flexWrap:"wrap", padding:"10px", background:"rgba(63,212,199,0.06)", border:`1px solid ${T.turkis}33`, borderRadius:8 }}> <select value={tilføj_type} onChange={e => setTilføjType(e.target.value)}
 style={{ background:"rgba(10,14,46,0.8)", border:"1px solid rgba(255,255,255,0.1)", borderRadius:6, padding:"6px 10px", color:T.creme, fontSize:12, fontFamily:"'Inter',system-ui,sans-serif" }}> <option value="email">Email</option> <option value="telefon">Telefon</option> </select> <input value={tilføj_vaerdi} onChange={e => setTilføjVaerdi(e.target.value)}
 onKeyDown={e => { if (e.key === 'Enter') tilføj(); }}
 placeholder={tilføj_type === 'email' ? 'email@eksempel.dk' : '+45 XX XX XX XX'}
 style={{ flex:"1 1 200px", background:"rgba(10,14,46,0.8)", border:"1px solid rgba(255,255,255,0.1)", borderRadius:6, padding:"6px 10px", color:T.creme, fontSize:12, fontFamily:"'Inter',system-ui,sans-serif" }} /> <input value={tilføj_label} onChange={e => setTilføjLabel(e.target.value)}
 placeholder="Label (fx 'Arbejde', 'Ægtefælle')"
 style={{ flex:"0 1 160px", background:"rgba(10,14,46,0.8)", border:"1px solid rgba(255,255,255,0.1)", borderRadius:6, padding:"6px 10px", color:T.creme, fontSize:12, fontFamily:"'Inter',system-ui,sans-serif" }} />
 {tilføj_type === 'telefon' && (
 <label style={{ display:"flex", alignItems:"center", gap:5, fontSize:11, color:T.dæmpet, cursor:"pointer", flex:"0 1 auto" }}
 title="Fx en Familieretshus-sagsbehandlers eget nummer, der kan være registreret på flere klienter — opkald fra det lægges altid i opkaldskøen til bekræftelse i stedet for at blive gættet.">
 <input type="checkbox" checked={tilføj_delt_nummer} onChange={e => setTilføjDeltNummer(e.target.checked)} />
 Delt/organisationsnummer
 </label>
 )}
 <button onClick={tilføj} style={{ background:T.turkis, border:"none", borderRadius:6, padding:"6px 14px", color:"#fff", fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>Tilføj</button> </div>
 )}
 {/* Emails */}
 <div style={{ marginBottom: tlfer.length ? 8 : 0 }}>
 {!compact && <div style={{ fontSize:11, color:T.dæmpet, marginBottom:4, letterSpacing:"0.05em" }}>EMAIL</div>}
 {!skjul_primaer && klient_primaer_email && (
 <div style={{ fontSize:13, color:T.creme, padding:"6px 10px", background:"rgba(63,212,199,0.08)", borderRadius:6, marginBottom:4, display:"flex", justifyContent:"space-between", alignItems:"center", gap:8 }}> <span><span style={{ fontSize:10, color:T.turkis, background:`${T.turkis}22`, padding:"1px 6px", borderRadius:4, marginRight:6, fontWeight:600, letterSpacing:"0.05em" }}>PRIMÆR</span>{klient_primaer_email}</span> <span style={{ fontSize:11, color:T.dæmpet, fontStyle:"italic" }}>(rediger via "Rediger klient")</span> </div>
 )}
 {emails.map(k => (
 <div key={k.id} style={{ fontSize:12, color:"#cbd5e1", padding:"5px 10px", background:"rgba(255,255,255,0.04)", borderRadius:6, marginBottom:3, display:"flex", justifyContent:"space-between", alignItems:"center", gap:8 }}> <span> {k.label && <span style={{ fontSize:11, color:T.dæmpet, marginRight:6 }}>[{k.label}]</span>}{k.vaerdi}</span> <button onClick={() => slet(k.id, k.vaerdi)} style={{ background:"none", border:"none", color:T.roed, fontSize:11, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif", opacity:0.7 }}>Slet</button> </div>
 ))}
 {!compact && !klient_primaer_email && emails.length === 0 && (
 <div style={{ fontSize:12, color:T.dæmpet, fontStyle:"italic" }}>Ingen email registreret</div>
 )}
 </div>
 {/* Telefoner */}
 <div>
 {!compact && <div style={{ fontSize:11, color:T.dæmpet, marginBottom:4, letterSpacing:"0.05em" }}>TELEFON</div>}
 {!skjul_primaer && klient_primaer_telefon && (
 <div style={{ fontSize:13, color:T.creme, padding:"6px 10px", background:"rgba(63,212,199,0.08)", borderRadius:6, marginBottom:4, display:"flex", justifyContent:"space-between", alignItems:"center", gap:8 }}> <span><span style={{ fontSize:10, color:T.turkis, background:`${T.turkis}22`, padding:"1px 6px", borderRadius:4, marginRight:6, fontWeight:600, letterSpacing:"0.05em" }}>PRIMÆR</span>{klient_primaer_telefon}</span> <span style={{ fontSize:11, color:T.dæmpet, fontStyle:"italic" }}>(rediger via "Rediger klient")</span> </div>
 )}
 {tlfer.map(k => (
 <div key={k.id} style={{ fontSize:12, color:"#cbd5e1", padding:"5px 10px", background:"rgba(255,255,255,0.04)", borderRadius:6, marginBottom:3, display:"flex", justifyContent:"space-between", alignItems:"center", gap:8 }}> <span> {k.label && <span style={{ fontSize:11, color:T.dæmpet, marginRight:6 }}>[{k.label}]</span>}{k.vaerdi}
 {k.delt_nummer && <span title="Delt/organisationsnummer — opkald lægges altid i opkaldskøen" style={{ fontSize:10, color:"#fbbf24", background:"rgba(251,191,36,0.15)", padding:"1px 6px", borderRadius:4, marginLeft:6, fontWeight:600, letterSpacing:"0.03em" }}>DELT</span>}
 </span> <span style={{ display:"flex", alignItems:"center", gap:10 }}>
 {!compact && (
 <label style={{ display:"flex", alignItems:"center", gap:4, fontSize:10, color:T.dæmpet, cursor:"pointer" }}
 title="Fx en Familieretshus-sagsbehandlers eget nummer, der kan være registreret på flere klienter.">
 <input type="checkbox" checked={!!k.delt_nummer} onChange={() => toggle_delt_nummer(k)} /> Delt
 </label>
 )}
 <button onClick={() => slet(k.id, k.vaerdi)} style={{ background:"none", border:"none", color:T.roed, fontSize:11, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif", opacity:0.7 }}>Slet</button>
 </span> </div>
 ))}
 {!compact && !klient_primaer_telefon && tlfer.length === 0 && (
 <div style={{ fontSize:12, color:T.dæmpet, fontStyle:"italic" }}>Intet telefonnummer registreret</div>
 )}
 {compact && emails.length === 0 && tlfer.length === 0 && !vis_tilføj && (
 <div style={{ fontSize:11, color:T.dæmpet, fontStyle:"italic" }}>Ingen alternative registreret</div>
 )}
 </div>
 {indlæser && <div style={{ fontSize:11, color:T.dæmpet, marginTop:6 }}>Indlæser…</div>}
 </div>
 );
}
// V1.3.2: Kompakt info-linje til sag-overblik. Viser adresse + alternative kontakter
// (read-only). Administration sker via rediger-dialogerne.
function KlientKontaktLinje({ klient_id, adresse, postnr, by }) {
 const [kontakter, setKontakter] = useState([]);
 React.useEffect(() => {
 if (!klient_id) return;
 api(`klient-kontakter/klient/${klient_id}`)
 .then(d => setKontakter(d?.kontakter || []))
 .catch(() => setKontakter([]));
 }, [klient_id]);
 const adresse_tekst = [adresse, [postnr, by].filter(Boolean).join(' ')].filter(Boolean).join(', ');
 const alt_emails = kontakter.filter(k => k.type === 'email');
 const alt_tlfer = kontakter.filter(k => k.type === 'telefon');
 if (!adresse_tekst && alt_emails.length === 0 && alt_tlfer.length === 0) return null;
 return (
 <div style={{ marginTop:10, padding:"8px 12px", background:"rgba(255,255,255,0.02)", border:"1px solid rgba(255,255,255,0.06)", borderRadius:8, fontSize:12, color:"#cbd5e1", display:"flex", flexWrap:"wrap", gap:14, alignItems:"center" }}>
 {adresse_tekst && (
 <span title="Klient-adresse"> <span aria-hidden="true" style={{ marginRight:4, opacity:0.7 }}></span>
 {adresse_tekst}
 </span>
 )}
 {alt_emails.length > 0 && (
 <span title="Alternative emails"> <span aria-hidden="true" style={{ marginRight:4, opacity:0.7 }}></span>
 {alt_emails.map(k => k.label ? `${k.label}: ${k.vaerdi}` : k.vaerdi).join(' · ')}
 </span>
 )}
 {alt_tlfer.length > 0 && (
 <span title="Alternative telefoner"> <span aria-hidden="true" style={{ marginRight:4, opacity:0.7 }}></span>
 {alt_tlfer.map(k => k.label ? `${k.label}: ${k.vaerdi}` : k.vaerdi).join(' · ')}
 </span>
 )}
 </div>
 );
}
export { KlientKontakterPanel, KlientKontaktLinje };
export default NyKlient;